import { action } from 'easy-peasy';

import { IActionSetNetworkActiveTab } from '../types';

const setNetworkActiveTab: IActionSetNetworkActiveTab = action((state, payload) => {
  state.activeTab = payload;
});

export default setNetworkActiveTab;
